import { Text, View } from '@react-pdf/renderer';
import { IntlFormatters } from 'react-intl';

import { filterDeletedValues } from 'lib/utils';
import { whiteLabelName } from 'lib/whitelabel';
import {
  hasDiffDates,
  lessThanPeriodDuration,
  yearsAndMonthsDuration,
} from 'components/Duration/utils';
import { rangeText } from 'components/Range/utils';
import messages from '../messages';
import { styles } from './styles';

const primaryColor = whiteLabelName === 'matchy' ? '#4941a0' : '#0097b3';

type CompanyExperienceProps = {
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfCompanyExperience = ({ formatMessage, profile }: CompanyExperienceProps) => {
  const positions = filterDeletedValues(profile.currentPositions.concat(profile.previousPositions));

  const renderPositions = positions.map(
    ({ position, displayDescription, companyName, startYear, endYear, startMonth, endMonth }) => {
      const { description = '' } = displayDescription[0] || { description: '' };
      const getDurationText = hasDiffDates({ endYear, endMonth, startMonth, startYear })
        ? yearsAndMonthsDuration({
            startYear,
            endYear,
            startMonth,
            endMonth,
            isShortFormat: false,
            formatMessage,
          })
        : lessThanPeriodDuration({ startMonth, endMonth, isShortFormat: false, formatMessage });
      const getRangeText = rangeText({
        endYear,
        endMonth,
        startMonth,
        startYear,
        formatMessage,
        format: 'short',
      });

      const renderCompanyName = (
        <Text
          style={{
            ...styles.subheading,
            ...styles.bold,
            color: primaryColor,
          }}
        >
          {companyName}
        </Text>
      );
      /* const renderDurationText = (
        <Text style={[styles.text, { marginBottom: 12 }]}>{getDurationText}</Text>
      ); */
      const renderPositionName = position ? (
        <Text style={[styles.bold, styles.text, { marginBottom: 2 }]}>{position}</Text>
      ) : null;
      const renderRangeText = getRangeText ? (
        <Text style={{ ...styles.text, marginBottom: 12 }}>
          {getRangeText} • {getDurationText}
        </Text>
      ) : null;
      const renderDescription = description ? (
        <Text style={[styles.text, styles.spaceBottomBig]}>{description}</Text>
      ) : null;

      return (
        <View>
          {renderCompanyName}
          {renderPositionName}
          {renderRangeText}
          {renderDescription}
        </View>
      );
    }
  );

  return (
    <View style={styles.section}>
      <Text style={[styles.subheading, styles.spaceBottom, styles.bold]}>
        {formatMessage(messages.workExperience)}
      </Text>
      <View style={{ marginLeft: 24 }}>{renderPositions}</View>
    </View>
  );
};
